import {
  WEBSITE,
  WEBSITE_NAME,
  WEBSITE_URL,
  WEBSITE_BIO,
  WEBSITE_TEMPLATE
 } from '../constants';

const initialStateWebsite = {}

export const website = (state=initialStateWebsite, action={}) => {
  switch (action.type) {
    case WEBSITE:
      return Object.assign({}, state, {sites: action.payload})
    case WEBSITE_URL:
      return Object.assign({}, state, {url: action.payload})
    case WEBSITE_NAME:
      return Object.assign({}, state, {name: action.payload})
    case WEBSITE_BIO:
      return Object.assign({}, state, {bio: action.payload})
    case WEBSITE_TEMPLATE:
      return Object.assign({}, state, {template: action.payload})
    default:
      return state
  }
}